// extracted by mini-css-extract-plugin
module.exports = {"header":"Tax_header__5LUGx","container":"Tax_container__R7iyq"};